import React from "react";

interface ModalAnswerProps {
  open: boolean;
  onClose: () => void;
  children: React.ReactNode;
}

const ModalAnswer = ({ open, onClose, children }: ModalAnswerProps) => {
  return (
    <div
      onClick={onClose}
      className={` fixed inset-0 flex justify-center items-center transition-colors ${
        open ? "visible bg-black/20" : "invisible"
      }`}
    >
      <div
        className={`rounded-4xl shadow p-8 transition-all ${
          open ? "scale-100 opacity-100" : "scale-125 opacity-0"
        }`}
      >
        {children}
      </div>
    </div>
  );
};

export default ModalAnswer;
